import bannerImg from './banners/woman-helping-man-gym.jpg';


export default {
    id: 'satisfacao',
    title: 'Pesquisa de satisfação',
    description: 'Meça a satisfação do seu público, identifique pontos de melhoria e colete sugestões valiosas.',
    indicatedFor: 'Criadores de conteúdo',
    stepsCount: 1,
    questionsSummary: ['Nível de satisfação', 'O que mais gostou', 'O que melhorar', 'Indicaria para amigos?'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Pesquisa de satisfação',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Sua experiência',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: 'Qual é o seu nível de satisfação geral?',
                        description: null,
                        required: true,
                        settings: {
                            max: 5,
                            min: 1,
                            maxLabel: 'Muito satisfeito',
                            minLabel: 'Insatisfeito',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: 'O que você mais gostou?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: 'O que podemos melhorar?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'yes_no_maybe',
                        label: 'Você indicaria para um amigo?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
